import { Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

// Answers the uuids of the removed subordinates.
function removeSubordinates(httpClient: HttpClient) {
  return (manager: Identifiable<Resource>) =>
    httpClient.sendHttpRequest<string[]>({
      endpoint: `/resources/${manager.uuid}/subordinates`,
      method: HttpMethods.DELETE,
    });
}

export { removeSubordinates };
